import { render, staticRenderFns } from "./add-text.vue?vue&type=template&id=f2acffa6&scoped=true"
import script from "./add-text.vue?vue&type=script&lang=js"
export * from "./add-text.vue?vue&type=script&lang=js"
import style0 from "./add-text.vue?vue&type=style&index=0&id=f2acffa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2acffa6",
  null
  
)

export default component.exports